import z from 'zod'

export const ONBOARDING_SCHEMA = z.object({
    fullName: z
        .string({ error: 'Please enter your full name' })
        .trim()
        .min(1, 'Please enter your full name')
        .refine((value) => value.trim().includes(' '), {
            message: 'Please enter both your first and last name',
        }),
})

export type IOnboardingFormData = z.infer<typeof ONBOARDING_SCHEMA>

export const ONBOARDING_INTRO_PROMPT = 'Hi Superscale, I am new here. Ask me 2 questions to get started.'
